module.exports = __webpack_public_path__ + "src/assets/img/text01.f4da138e.png";